module.exports = __webpack_public_path__ + "static/media/fila_black.9dab2fa2.jpg";